import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { RotatingLines } from "react-loader-spinner";
import $ from "jquery";
import APIUrls from '../../services/APIUrls'
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods'
import { dateConvertToTimeStamp, dateInUTC,timeStamp, dateFormat, utcDateTimeWithTimeZone ,utcDateTimeWithTimeZoneWithFormat, transformBlankToNull, PROJECT_DATE_FORMAT, TIME_LIST } from '../../services/Util'
import { updateProjectInfo , updateNextStepEvent } from '../../redux/reducers/ProjectInfoSlice';
import { updateBidRequestInfo } from '../../redux/reducers/BidRequestSlice';
import Constants from '../../Constants';
import { TranslationPreference } from './TranslationPreference';
import { ConditionalBlock } from '../../ConditionalBlock';

export const MultiVendors = () => {

  const { t } = useTranslation();
  const translate = t;

  const [targetLanguageList, setTargetLanguageList] = useState([])//this contains language objects
  const [allPurchaseOrdersOptions, setAllPurchaseOrdersOptions] = useState([])
  const [purchaseOrdersOptions, setPurchaseOrdersOptions] = useState([])
  const [currencyOptions, setCurrencyOptions] = useState([])
  const [biddingVendors,setBiddingVendors] = useState([]); //vendors who can participate in bidding
  const [bidLessVendors,setBidLessVendors] = useState([]);
  const [validateTranslationPreference, setValidateTranslationPreference] = useState(false);
  const [translationPreferences, setTranslationPreferences] = useState([]);
  const [purchaseOrder, setPurchaseOrder] = useState(null);
  const [notes, setNotes] = useState("");
  const [currency, setCurrency] = useState(null);
  const [globalOverlay,showGlobalOverlay] = useState(true);
  const [validatedPreferencesCount,setValidatedPreferencesCount] = useState(0);

  const dispatch = new useDispatch();
  const params = useParams();
  const bootstrapData = useSelector(store => store.customer_bootstrap_data).value;
  const permissions = bootstrapData?.permissions;
  const features = bootstrapData?.features;

  const projectData = useSelector(
    (reduxStore) => reduxStore.project_info
  ).value;

  const custBootstrapDataRedux = useSelector(reduxStore => reduxStore.customer_bootstrap_data).value;

  const dispatchFinalDataToRedux = (type, value) => {
    dispatch(updateProjectInfo({
      type: type,
      value: value
    }));
  }
  const dispatchFinalDataToToBidRequest = (type, value) => {
    dispatch(updateBidRequestInfo({
      type: type,
      value: value
    }));
  }

  const onNotesChange = (event) => {
    setNotes(event.target.value);
  }

  const setProjectCurrency = (event) => {
    if(event !==null){
      const currencies = currencyOptions.filter(data => data.value === event?.value);
      setCurrency(currencies[0]);
      setPurchaseOrdersOptions(allPurchaseOrdersOptions.filter((order) => order.currency === event?.value));
       setPurchaseOrder(null);
    }else{
      setCurrency(null);
    }
  }

  const setCustomerPurchaseOrder = (event) => {
    if(event !==null){
      const purchaseOrders = purchaseOrdersOptions.filter(data => data.value === event?.value)
      setPurchaseOrder(purchaseOrders[0]);
    }else{
      setPurchaseOrder(null);
    }
  }

//on validating the form we get the data with validation failed flag
  const onTranslationPreferenceValidation = (data) =>{
    let newData = translationPreferences;
    newData.push(data);
    setTranslationPreferences(newData);
    setValidatedPreferencesCount(newData?.length);
  }

  const convertToDbDateTime = (date, userTz) =>{
    let currDate = new Date();
    let userTimeStr = utcDateTimeWithTimeZoneWithFormat(currDate,Constants.DATE_FORMAT_MM_DD_YYYY_24_HH_MM_SS,userTz);
    let userTzDate = new Date(userTimeStr);
    let diffInMillis = userTzDate.getTime() - currDate.getTime();
    let dbDate = new Date(date.getTime() - diffInMillis);
    dbDate.setSeconds(0);
    dbDate.setMilliseconds(0);
    return dbDate;
  }

  const convertToUserDateTime = (date, userTz) =>{
    let userTimeStr = utcDateTimeWithTimeZoneWithFormat(date,Constants.DATE_FORMAT_MM_DD_YYYY_24_HH_MM_SS,userTz);
    let userTzDate = new Date(userTimeStr);
    return userTzDate;
  }

  const userCurrentDateTime = (userTz) =>{
      let date = new Date();
      let userTimeStr = utcDateTimeWithTimeZoneWithFormat(date,Constants.DATE_FORMAT_MM_DD_YYYY_24_HH_MM_SS,userTz);
      let userTzDate = new Date(userTimeStr);
      userTzDate.setMinutes(0);
      userTzDate.setSeconds(0);
      return userTzDate;
  }

  let userTimezone = custBootstrapDataRedux.user?.timeZone;

  const submitData = () => {

    if(custBootstrapDataRedux?.features?.INTERNATIONAL_CURRENCY && currency != null){
        dispatchFinalDataToRedux('currency', currency)
    }
    dispatchFinalDataToRedux('purchaseOrder', purchaseOrder);
    dispatchFinalDataToRedux('notes', notes);

    let sortedTranslationPreferences = []; //sort in order of target languages
    targetLanguageList.map((language,index) => {
        let langPrefs = translationPreferences.filter((data) => data.language === language.language);
        let preference = langPrefs[0];
        let bidDueDate = Object.assign({}, preference.bidDueDate);
        bidDueDate = timeStamp(preference.bidDueDate, userTimezone);
        let deliveryDueDate = Object.assign({}, preference.deliveryDueDate);
        deliveryDueDate = timeStamp(preference.deliveryDueDate, userTimezone);
        preference.bidDueDate = preference.bidDueDate === null ? null : bidDueDate;
        preference.deliveryDueDate = preference.deliveryDueDate === null ? null : deliveryDueDate;
        sortedTranslationPreferences.push(preference);
        if(index === (targetLanguageList.length -1) ){//set the last language record preference in redux for the source project
            dispatchFinalDataToToBidRequest('preferredVendors',preference.vendors);
            dispatchFinalDataToRedux('autoSelectBid', preference.autoApproveBidRequest);
            dispatchFinalDataToRedux('bidDueDate', preference.bidDueDate);
            dispatchFinalDataToRedux('deliveryDueDate', preference.deliveryDueDate);
            dispatchFinalDataToRedux('projectVendorType', (preference.receiveQuotes ? 'EXTERNAL' : 'EXTERNAL_BIDLESS'));
        }
    });
    dispatchFinalDataToRedux('translationPreferences', sortedTranslationPreferences);

    dispatch(updateNextStepEvent({
        target: 'Translation Request',
        action : 'save'
    }));
  }

  const getLanguageTranslationPreferences = (language) =>{
    let data = translationPreferences.filter((data) => {
        return data.language === language.language;
    });
    return data?.length > 0 ? data[0] : {};
  }

  useEffect(() => {

        if(!projectData.status){
            dispatchFinalDataToRedux(
                'status', 'CONFIGURED_BID_OPTIONS'
            )
        }

        const projectId = projectData?.id;
        const deptId = projectData?.userGroup?.id;

        getAxiosResponse(APIUrls.PREFERRED_VENDORS(deptId))
        .then((res)=>{
            const vendors = res?.data?.data.map(({vendor}) => ({...vendor, value: vendor.id, label: vendor.name}));
            setBiddingVendors(vendors);
        });

        getAxiosResponse(APIUrls.TRANSALATION_VENDORS(deptId))
        .then((res)=>{
            const vendors = res?.data?.data.map(({vendor})  => ({...vendor, value: vendor.id, label: vendor.name}));
            setBidLessVendors(vendors);
        });

        getAxiosResponse(APIUrls.CUSTOMER_PURCHASE_ORDER)
        .then((res)=>{
            let purchaseOrders = res?.data?.data.map((purchaseOrder)  => ({...purchaseOrder, value: purchaseOrder.id, label: purchaseOrder.shortDisplay}));
            setAllPurchaseOrdersOptions(purchaseOrders);
            if(projectData?.currency){
                purchaseOrders = purchaseOrders.filter(data => data.currency === projectData?.currency);
            }
            setPurchaseOrdersOptions(purchaseOrders);
            if(projectData?.purchaseOrder){
                const selectedPurchaseOrders = purchaseOrders.filter(data => data.value === projectData?.purchaseOrder?.id)
                setPurchaseOrder(selectedPurchaseOrders[0]);
            }
        });

        if(custBootstrapDataRedux?.features?.INTERNATIONAL_CURRENCY) {
            getAxiosResponse(APIUrls.AVAILABLE_CURRENCY(projectId))
            .then((res)=>{
                const currencies = res?.data?.data.map((currency)  => ({...currency, value: currency.code}));
                setCurrencyOptions(currencies);
                if(projectData?.currency){
                    const selectedCurrencies = currencies.filter(data => data.value === projectData?.currency);
                    setCurrency(selectedCurrencies[0]);
                }
            });
        }
        showGlobalOverlay(false);

        let translationPreferencesRedux = projectData?.translationPreferences;
        if(translationPreferencesRedux?.length > 0){
            let preferences = [];//format backend data to support dropdown options data format
            translationPreferencesRedux?.map(translationPreference => {
                const vendors = translationPreference?.vendors.map((vendor) => ({...vendor, value: vendor.id, label: vendor.name}));
                let preference = Object.assign({}, translationPreference);
                preference.vendors = vendors;
                preference.bidDueDate = preference.bidDueDate?.utcTimestamp ? convertToUserDateTime(new Date(preference.bidDueDate.utcTimestamp), userTimezone) : null;
                preference.deliveryDueDate = preference.deliveryDueDate?.utcTimestamp ? convertToUserDateTime(new Date(preference.deliveryDueDate.utcTimestamp), userTimezone) : null;
                preferences.push(preference);
            });
            setTranslationPreferences(preferences);
        }
        setTargetLanguageList(projectData.targetLanguageList);
  },[]);

  useEffect(()=>{
    if(projectData?.nextStepEvent && projectData?.nextStepEvent.target === "Translation Request"
        && projectData?.nextStepEvent.action === 'validate' ){
        setTranslationPreferences([]);
        setValidateTranslationPreference(true);
        setValidatedPreferencesCount(0);
    }
  },[projectData]);

   useEffect(()=>{

        if(validatedPreferencesCount === targetLanguageList.length && targetLanguageList.length > 0){ // if validated for all the languages
            let validationFailed = false;
            translationPreferences.map(preference => {
                validationFailed = validationFailed || preference.validationFailed;
            });
            if(!validationFailed){
                submitData();
            }
            setValidateTranslationPreference(false);
        }
   },[translationPreferences,validatedPreferencesCount]);


  return (
    <>
      <div className="translate-project translate-vender">
        <div className="project-heading mar-bot10">
          <h3>Multi-Vendors Translation</h3>
        </div>
        <div className="vendor-content">
          <h5>Select vendor against target language</h5>
          {
          (biddingVendors.length > 0  || bidLessVendors.length > 0)
          ?
          <div className="mar-bot30 mar-top20">
            {
                targetLanguageList.map((targetLanguage, index) => (
                        <TranslationPreference
                            componentId = {'tp-'+index}
                            key = {'tp-'+index}
                            userCurrentDateTime={userCurrentDateTime(userTimezone)}
                            language = {targetLanguage}
                            bidLessFeatureEnabled = {features?.BIDLESS_PROJECTS}
                            autoApproveFeatureEnabled = {features?.AUTO_APPROVE_BID && permissions?.BID_AUTO_APPROVAL}
                            biddingVendors = {biddingVendors}
                            bidLessVendors = {bidLessVendors}
                            validateForm = {validateTranslationPreference}
                            onValidation = {onTranslationPreferenceValidation}
                            preferenceData={getLanguageTranslationPreferences(targetLanguage)}
                        />
                     )
                )
             }
          </div>
          :
          <div className="mar-bot30 mar-top20"><p>Please contact OPAL-Marketing to configure vendors for this department. <a target={"_blank"} href='/vendor/customer-vendor/'>Add preferred vendors</a> to your account to request quotes from your preferred vendors.</p></div>
          }
          <div className="vender-form-block">
          <ConditionalBlock condition={custBootstrapDataRedux?.features?.INTERNATIONAL_CURRENCY && currencyOptions.length > 0}>
            <div className="flex wrap-dropdown">
              <div className="global-dropdown-block flex-center">
                <label>{translate("machine_vendor.project_currency")}</label>
                <div className="global-dropdown-select">
                  <Select className="global-dropdown-select" classNamePrefix='cw'
                    value={currency}
                    aria-label="Project Currency"
                    options={currencyOptions}
                    onChange={event => setProjectCurrency(event)}
                    menuShouldScrollIntoView={false}
                  />
                </div>
              </div>
            </div>
           </ConditionalBlock>
            <div className="flex wrap-dropdown">
              <div className="global-dropdown-block flex-center">
                <label>{translate("project_listing.purchase_order_number")} <span> {translate("project_listing.optional")}</span></label>
                <div className="global-dropdown-select">
                  <Select className="global-dropdown-select" classNamePrefix='cw'
                    value={purchaseOrder}
                    aria-label="Purchase Order Number (Optional)"
                    options={purchaseOrdersOptions}
                    isClearable={true}
                    onChange={event => setCustomerPurchaseOrder(event)}
                    menuShouldScrollIntoView={false}
                  />
                </div>
              </div>
            </div>
            <div className="flex wrap-dropdown textarea-group mar-bot10">
              <div className="global-dropdown-block flex-center mb-0">
                <label htmlFor='descriptions'>{translate("project_listing.vendors_instruction")}</label>
                <textarea maxLength="2500" id='descriptions' className="textarea" name='notes'
                  onChange={event => onNotesChange(event)} placeholder={translate("project_listing.charactacters_limit")} value={notes}
                 ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>
    </>
  )
}
